import { Logger } from "./logger";
import { LoggerService } from "./logger.service";

interface ILogSettings {
  level: "debug" | "error" | "info" | "warn";
}

export function LogMethod(settings?: ILogSettings): MethodDecorator {
  // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
  return (target: Function, key: string, descriptor: any): any => {
    const originalMethod = descriptor.value;
    let level = "debug";
    if (settings && settings.level) {
      level = settings.level;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    descriptor.value = function (...args: any[]): any {
      //Must not be an arrow function, so this is really the calling this
      let logger = LoggerService.get(target);
      if (logger === null) {
        logger = new Logger(target.prototype.name);
      }
      logger[level](`Entering ${key} method`);
      const start = performance.now();
      const result = originalMethod.apply(this, args);
      const end = performance.now();
      logger[level](`Leaving ${key} method - ~ ${end - start} milliseconds.`);
      return result;
    };

    return descriptor;
  };
}
